import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faGift } from "@fortawesome/free-solid-svg-icons"

export const Gift = (props) => {
  return <FontAwesomeIcon faIcon={faGift} {...props} />
}
